"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronUp = function ChevronUp(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M7.4038 16.5962C8.46715 17.6596 9.86631 18.3213 11.3629 18.4687C12.8594 18.6161 14.3608 18.24 15.6112 17.4046C16.8616 16.5691 17.7836 15.3259 18.2201 13.8869C18.6566 12.4478 18.5807 10.9019 18.0052 9.51257C17.4297 8.12323 16.3903 6.97641 15.0641 6.26752C13.7378 5.55863 12.2068 5.33153 10.7319 5.62491C9.25699 5.91828 7.92943 6.71399 6.97543 7.87645C6.02142 9.03891 5.49999 10.4962 5.49999 12C5.49766 12.8539 5.66472 13.6999 5.99151 14.4888C6.3183 15.2777 6.79832 15.994 7.4038 16.5962Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 7.5C12.0657 7.49992 12.1307 7.51281 12.1914 7.53794C12.2521 7.56307 12.3072 7.59995 12.3535 7.64644L16.3535 11.6464C16.4473 11.7402 16.5 11.8674 16.5 12C16.5 12.1326 16.4473 12.2598 16.3535 12.3536C16.3071 12.4 16.252 12.4368 16.1913 12.4619C16.1307 12.4871 16.0657 12.5 16 12.5C15.8674 12.5 15.7402 12.4473 15.6464 12.3536L11.6464 8.35356C11.5765 8.28363 11.5289 8.19454 11.5096 8.09755C11.4903 8.00056 11.5002 7.90002 11.538 7.80866C11.5759 7.71729 11.64 7.63921 11.7222 7.58426C11.8044 7.52932 11.9011 7.5 12 7.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 7.5C12.0989 7.5 12.1956 7.52932 12.2778 7.58426C12.36 7.63921 12.4241 7.71729 12.4619 7.80866C12.4998 7.90002 12.5097 8.00056 12.4904 8.09755C12.4711 8.19454 12.4235 8.28363 12.3535 8.35356L8.35355 12.3536C8.30721 12.4004 8.25207 12.4376 8.1913 12.463C8.13053 12.4885 8.06534 12.5017 7.99946 12.5018C7.93358 12.502 7.86832 12.4892 7.80742 12.464C7.74652 12.4389 7.69119 12.402 7.64461 12.3554C7.59803 12.3088 7.56111 12.2535 7.53598 12.1926C7.51085 12.1317 7.498 12.0664 7.49817 12.0005C7.49834 11.9346 7.51153 11.8695 7.53698 11.8087C7.56243 11.7479 7.59964 11.6928 7.64647 11.6464L11.6465 7.64644C11.6928 7.59995 11.7479 7.56308 11.8086 7.53795C11.8693 7.51281 11.9343 7.49992 12 7.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

ChevronUp.defaultProps = {
  altText: "Chevron Up",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
ChevronUp.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ChevronUp;
exports.default = _default;